// Restore the webpack-era Buffer global. CRA's ProvidePlugin injected
// `Buffer` into every module that referenced it; Vite injects nothing.
// @react-pdf/pdfkit's BROWSER build reaches for the global from some scopes
// (~357 references, only partially self-vendored), so the client-side section
// preview died with "Buffer is not defined" on QA — while @react-pdf/image,
// the one path the old craco comment warned about, vendors its own shim and
// never needed this. One global here closes the whole class instead of
// chasing consumers per module. (O2 in docs/features/vite-migration/ —
// reopened and closed for real.)
//
// This file must be the FIRST import of src/index.jsx: ESM executes imports
// depth-first in declaration order, so this assignment lands before any other
// module in the app graph initializes.
import { Buffer } from 'buffer';

if (typeof globalThis.Buffer === 'undefined') globalThis.Buffer = Buffer;
